// src/services/demoApi/policiesApi.ts
// Политики компании (FR-5): общие системные промпты, которые дописываются
// к каждому запросу пользователя. Хранение — localStorage (demo_policies).
// Дефолтные политики ВЫКЛЮЧЕНЫ из коробки, чтобы не менять поведение чатов (NFR-1).
import { demoDelay, readDemoStore, writeDemoStore } from './demoStorage';

export interface CompanyPolicy {
  id: string;
  title: string;
  description: string;
  prompt: string;
  enabled: boolean;
  updatedAt: string; // ISO
}

const STORE_KEY = 'demo_policies';

const DEFAULT_POLICIES: CompanyPolicy[] = [
  {
    id: 'policy-data',
    title: 'Политика работы с данными',
    description: 'Запрет на раскрытие персональных данных и банковской тайны в ответах',
    prompt:
      'Никогда не раскрывай персональные данные клиентов, номера счетов, карт и сведения, ' +
      'составляющие банковскую тайну. При запросе таких данных — откажи и сошлись на ' +
      'политику работы с данными банка.',
    enabled: false,
    updatedAt: '2026-06-01T09:00:00.000Z',
  },
  {
    id: 'policy-scenarios',
    title: 'Политика использования сценариев',
    description: 'Ограничение ответов рабочей тематикой и зоной ответственности роли',
    prompt:
      'Отвечай только на вопросы, связанные с рабочими задачами банка. На запросы вне ' +
      'рабочей тематики вежливо откажи и предложи обратиться к утверждённым сценариям.',
    enabled: false,
    updatedAt: '2026-06-01T09:00:00.000Z',
  },
];

/** Синхронное чтение — нужно в точке отправки сообщения (promptDecorators) */
export function listPoliciesSync(): CompanyPolicy[] {
  return readDemoStore<CompanyPolicy[]>(STORE_KEY, DEFAULT_POLICIES);
}

export async function listPolicies(): Promise<CompanyPolicy[]> {
  await demoDelay(200);
  return listPoliciesSync();
}

export async function savePolicy(
  input: { title: string; description: string; prompt: string },
  id?: string
): Promise<CompanyPolicy> {
  await demoDelay(400);
  const policies = listPoliciesSync();
  if (id) {
    const next = policies.map((p) =>
      p.id === id ? { ...p, ...input, updatedAt: new Date().toISOString() } : p
    );
    writeDemoStore(STORE_KEY, next);
    return next.find((p) => p.id === id) as CompanyPolicy;
  }
  const created: CompanyPolicy = {
    id: `policy-${Date.now()}`,
    ...input,
    enabled: false,
    updatedAt: new Date().toISOString(),
  };
  writeDemoStore(STORE_KEY, [...policies, created]);
  return created;
}

export async function setPolicyEnabled(id: string, enabled: boolean): Promise<void> {
  await demoDelay(200);
  const next = listPoliciesSync().map((p) =>
    p.id === id ? { ...p, enabled, updatedAt: new Date().toISOString() } : p
  );
  writeDemoStore(STORE_KEY, next);
}

export async function deletePolicy(id: string): Promise<void> {
  await demoDelay(250);
  writeDemoStore(
    STORE_KEY,
    listPoliciesSync().filter((p) => p.id !== id)
  );
}
